import React, { useState } from "react";
import { v4 as uuid } from "uuid";

const useFileDownloader = () => {
  const [files, setFiles] = useState([]);

  const downloadFile = (file) => {
    setFiles([...files, { ...file, downloadId: uuid() }]);
  };

  const remove = (removeId) =>
    setFiles([...files.filter((file) => file.downloadId !== removeId)]);

  return {
    files,
    downloadFile,
    remove,
  };
};

export default useFileDownloader;
